
import React from 'react';
import Layout from "@/components/layout/Layout";
import HeroSection from '@/components/about/HeroSection';
import OurStorySection from '@/components/about/OurStorySection';
import ValuesSection from '@/components/about/ValuesSection';
import TeamSection from '@/components/about/TeamSection';
import CTASection from '@/components/about/CTASection';

const About = () => {
  return (
    <Layout>
      <HeroSection />
      <OurStorySection />
      <ValuesSection />
      <TeamSection />
      <CTASection />
    </Layout>
  );
};

export default About;
